export default [
    {
        path: '/account-request',
        name: 'account-request',
        component: () => import(/* webpackChunkName: "account-request" */ '../pages/AccountRequest.vue'),
        meta: {
            title: 'REQUEST SECURED ACCESS',
            icon: 'mdi-lock',
            displayInNavigation: false,
            gtm: 'critical-infrastructure-data-access-request-form'
        }
    }
]
